import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ReplyTemplateForm from '../../../components/forms/ReplyTemplateForm';
import { useReplyTemplateApi } from '../../../hooks/useReplyTemplateApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ReplyTemplateDTO } from '../../../services/apiClient';

const ReplyTemplateCreate: React.FC = () => {
  const { create, isLoading } = useReplyTemplateApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Reply Templates', href: '/admin/replytemplates' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ReplyTemplateDTO) => {
    try {
      await create(data);
      navigate('/admin/replytemplates');
    } catch (error) {
      console.error('Error creating ReplyTemplate:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/replytemplates"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ReplyTemplate.Edit'
    >
        <ReplyTemplateForm
          initialValues={{} as ReplyTemplateDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/replytemplates')}
        />
    </AdminLayout>
  );
};

export default ReplyTemplateCreate;